import Route from '@ember/routing/route';

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — magic-link entry point: turns a `token` query param into
 *              an `access_token` query param and does a full-page redirect, so
 *              the normal session bootstrap (SessionService#bootSessionTask)
 *              picks it up on reload
 *   extends:   Route (@ember/routing/route)
 *   template:  beebee-base-template templates/token-login.hbs (waiting card / error card)
 *   model:     model(params) — state 'error' (the API's Google / invite redirects:
 *              /token_login/error/<reason>, reason = seats_full | exists | error) returns
 *              { error: <reason> } for the template and does NOT navigate: the reason is
 *              not a token (it used to be handed off as `?access_token=seats_full`, which
 *              only produced a 401 and the login page with no word of why). Otherwise, if
 *              params.token is present, replaces window.location with
 *              `<baseUrl>?access_token=<token>` (baseUrl = current href with the
 *              token-login path segment stripped); no-op if params.token is absent
 *   key:       model()
 *   uses:      -
 *   siblings:  - (consuming apps map their own `token_login` route to this class)
 *   tests:     token-login-test.js
 *   gotchas:   navigation goes through the `_location` getter (window.location),
 *              not a direct global reference, so tests can stub it instead of
 *              triggering a real page redirect.
 */
class TokenLoginRoute extends Route {
  get _location() {
    return window.location;
  }
  model(params) {
    // POP-665: an error outcome carries a reason, not a token — show it, never log in with it
    if (params.state === 'error') {
      return {
        error: params.token || 'error'
      };
    }
    if (!params.token) {
      return;
    }
    const loc = this._location;
    const baseUrl = loc.href.replace(/token[-_]login.*$/, '');
    loc.replace(`${baseUrl}?access_token=${encodeURIComponent(params.token)}`);
  }
}

export { TokenLoginRoute as default };
//# sourceMappingURL=token-login.js.map
